/* «Seguir viendo»: recuerda en ESTE navegador los productos que la persona abrió.
   No usa cuenta ni cookies de terceros: solo localStorage. Si no hay historial, la sección se oculta. */
(function () {
  var CLAVE = 'fusfit_vistos', TOPE = 12;

  function leer() {
    try { return JSON.parse(localStorage.getItem(CLAVE) || '[]'); } catch (e) { return []; }
  }
  function guardar(lista) {
    try { localStorage.setItem(CLAVE, JSON.stringify(lista.slice(0, TOPE))); } catch (e) {}
  }

  // 1) Si estamos en una ficha de producto, la registramos.
  var d = document.getElementById('ff-visto-actual');
  if (d) {
    var item = {
      handle: d.dataset.handle, titulo: d.dataset.titulo, img: d.dataset.img,
      // Id del producto: lo usa el buscador para pedir recomendados a Shopify.
      id: parseInt(d.dataset.id || '0', 10) || null,
      precio: d.dataset.precio, precioBs: d.dataset.preciobs,
      // Colecciones del producto: alimentan el orden personalizado del muro de la portada.
      cols: d.dataset.cols || '',
      pct: parseInt(d.dataset.pct || '0', 10) || 0, ts: Date.now()
    };
    var lista = leer().filter(function (x) { return x.handle !== item.handle; });
    lista.unshift(item);
    guardar(lista);
  }

  // 2) Si hay un contenedor de «Seguir viendo», lo pintamos.
  var cont = document.querySelector('[data-ff-seguir-viendo]');
  if (!cont) return;
  var vistos = leer().filter(function (p) { return p && p.handle; });
  if (!vistos.length) return;                 // sin historial → la sección queda oculta
  var seccion = cont.closest('.ff-row');

  // TODAS las tarjetas se piden al servidor: son la MISMA tarjeta de la portada, con su botón de
  // agregado rápido, su precio de hoy y su stock real.
  //
  // Antes se pintaba primero una copia local (título, foto y precio guardados) y se iba
  // sustituyendo. Eso dejaba la fila DESPAREJA: la copia local no tiene botón —no sabe de
  // variantes ni de stock— y cualquier producto cuya petición fallara se quedaba sin él para
  // siempre. Pasa de verdad: un producto renombrado deja el handle viejo guardado en el
  // navegador. Ahora es todo o nada por tarjeta: si el servidor no la da, no se pinta.
  function pedirTarjeta(p) {
    return fetch('/products/' + encodeURIComponent(p.handle) + '?section_id=fusfit-tarjeta-suelta',
                 { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return null;
        var caja = document.createElement('div');
        caja.innerHTML = html.trim();
        return caja.querySelector('.ff-card');   // null si el producto ya no existe
      })
      .catch(function () { return null; });
  }

  function pintar() {
    Promise.all(vistos.map(pedirTarjeta)).then(function (tarjetas) {
      var buenas = tarjetas.filter(Boolean);
      if (!buenas.length) return;              // nada que enseñar: la sección sigue oculta
      cont.innerHTML = '';
      buenas.forEach(function (t) { cont.appendChild(t); });
      if (seccion) seccion.hidden = false;     // se enseña SOLO cuando ya hay algo que enseñar
    });
  }

  // Se pinta de una vez. OJO: nada de esperar a que la fila «entre en pantalla» con un
  // IntersectionObserver — la sección nace con hidden (display:none), no tiene caja, y un
  // elemento sin caja NUNCA interseca: la fila se quedaba muda para siempre. Son a lo sumo
  // 12 peticiones de una sección liviana, y solo cuando hay historial.
  pintar();
})();
